import { useState } from "react";
import { useEffect } from "react";

import {
  Card,
  CardBody,
  Form,
  Input,
  Label,
  Button,
  Container,
} from "reactstrap";
import JoditEditor from "jodit-react";
import { toast } from "react-toastify";
import { useRef } from "react";
import { createCms, BaseUrl, getCms, updateCms } from "../services/Url";
import { useNavigate, useParams } from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { Box, Grid, TextField, Typography } from "@mui/material";

const PrivacyPloicy = () => {
  const editor = useRef(null);
  const [info, setInfo] = useState();
  const [post, setPost] = useState();
  const [id, setId] = useState();
  const [error, setError] = useState(false);
  const [pname, setPname] = useState('');
  const [getcontent, setGetcontent] = useState(false);
  const navigate = useNavigate();
  const params = useParams();
  
  useEffect(() => {
    getCMSAbout();
  }, []);

  const createData = async () => {
    if(id){
      let data = {
        id,
        name: "Privacy Policy",
        content: post,
      };
      let token = localStorage.getItem("token");
      let CompleteUrl = BaseUrl + createCms;
  
      await fetch(CompleteUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
        body: JSON.stringify(data),
      })
        .then((res) => {
          if(res?.status === 200){
            toast?.success('Update Successfully')
           }
        })
        .catch((err) => {
          console.log(err);
        });
    }else{}
  };

  const getCMSAbout = async () => {
    let data = {
      name: "Privacy Policy",
    };
    let token = localStorage.getItem("token");
    let CompleteUrl = BaseUrl + getCms;

    let response = await fetch(CompleteUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    const jsonData = await response.json();
    if (jsonData.data != null) {
      setGetcontent(true);
      setInfo(jsonData.data.content);
      setId(jsonData.data._id);
      setPname(jsonData?.data?.name)
    }
  }; 

  const handleChange = (value) => {
    setPname(value)
  }

  return (
    <div className="wrapper">
      <Card className="shadow-sm border-0 mt-2">
        <CardBody>
          <div className="heading-btn_wrapper">
            <h5
              style={{ display: "inline-flex", cursor: "pointer" }}
              className="fz-20 fw-bold"
            >
              Privacy Policy
            </h5>
            <Button
              className="btn btn-design"
              onClick={() => navigate(`/privacyview`)}
            >
              View
            </Button>
          </div>
          <Form>
          {/* <Grid container spacing={2}>
          <Grid item xs={6}>
                <Box className="inpt_bx">
                  <Typography variant="h6">Page Name</Typography>
                  <TextField
                    fullWidth
                    disabled
                    name="pname"
                    placeholder="Name"                    
                    onChange={(e) => handleChange(e.target.value)}
                    value={pname}                    
                  />
                  {error?.length > 0 ? <p>Please Enter Page Name</p> : ''}
                </Box>
              </Grid>
            </Grid> */}
            <div className="my-3">
              {/* <Label for="content">Post Content</Label> */}

              <JoditEditor
                ref={editor}
                value={info}
                onChange={(newContent) => setPost(newContent)}
              />
            </div>

            <Container className="text-center">
              {/* {getcontent == false ? (
                <Button
                  className="rounded-0 ms-2"
                  color="danger"
                  onClick={() => createData()}
                >
                  Submit Content
                </Button>
              ) : ( */}
                <Button
                  className="rounded-0 ms-2"
                  color="success"
                  onClick={() => createData()}
                >
                  Save
                </Button>
              {/* )} */}
            </Container>
          </Form>
        </CardBody>
      </Card>
    </div>
  );
};

export default PrivacyPloicy;
